import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Checkbox, Row, Tooltip } from 'seagull';
import { QuestionCircle } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import s from './DisplayScopeCheckbox.module.scss';
export const GetDisplayScopeCheckboxTID = (parentTestId)=>getTestIds(parentTestId);
export const DisplayScopeCheckbox = (param)=>{
    let { checked, onChange, disabled, testId } = param;
    const { t } = useLocaleKeys();
    const testIds = useMemo(()=>GetDisplayScopeCheckboxTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Row, {
        testId: testIds.DisplayScopeCheckboxTestIds.Root(),
        gap: 4,
        alignItems: "center",
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                testId: testIds.DisplayScopeCheckboxTestIds.Checkbox(),
                checked: checked,
                onChange: onChange,
                disabled: disabled,
                label: t.customPages.includeInSignedAgreement(),
                bi: {
                    name: 'include_in_signed_agreement'
                }
            }),
            /*#__PURE__*/ _jsx(Tooltip, {
                title: t.customPages.includeInSignedAgreementTooltip(),
                children: /*#__PURE__*/ _jsx("span", {
                    className: s.tooltipIcon,
                    "data-testid": testIds.DisplayScopeCheckboxTestIds.TooltipIcon(),
                    children: /*#__PURE__*/ _jsx(QuestionCircle, {
                        size: 14
                    })
                })
            })
        ]
    });
};
